enum ENVIRONMENT {
  'local', 'dev', 'preprod', 'prod', 'localtest'
}

const LOCALTEST = false; // Set to true when testing backend locally 

const getEnv = () => {
  if(LOCALTEST) {
    console.log("TESTING LOCALLY");
    return ENVIRONMENT.localtest;
  } else {
    const hostname = window && window.location && window.location.hostname;
    switch (hostname) {
      case 'localhost':
        return ENVIRONMENT.local;
      case 'numerusapp.z16.web.core.windows.net':
        return ENVIRONMENT.dev;
      case 'numerusnova-test.serty.fi':
      case 'numetapp.z16.web.core.windows.net':
        return ENVIRONMENT.preprod;
      case 'numerusnova.serty.fi':
      case 'numerusnova.z16.web.core.windows.net':
        return ENVIRONMENT.prod;
      default:
        return ENVIRONMENT.local;
    }
  }
}

const LOGIN_URLS = {
  [ENVIRONMENT.local]: 'http://localhost:3000',
  [ENVIRONMENT.dev]: 'https://numerusapp.z16.web.core.windows.net/',
  [ENVIRONMENT.preprod]: 'https://numerusnova-test.serty.fi/',
  [ENVIRONMENT.prod]: 'https://numerusnova.serty.fi/',
  [ENVIRONMENT.localtest]: 'http://localhost:3000'
}

const BASE_URLS = {
  [ENVIRONMENT.local]: 'https://numdev-functions.azurewebsites.net',
  [ENVIRONMENT.dev]: 'https://numdev-functions.azurewebsites.net',
  [ENVIRONMENT.preprod]: 'https://numet-functions.azurewebsites.net',
  [ENVIRONMENT.prod]: 'https://numerus-functions.azurewebsites.net',
  [ENVIRONMENT.localtest]: 'http://localhost:7071'
}

const CLIENT_IDS = {
  [ENVIRONMENT.local]: 'be3c39b7-1429-428d-8b8f-c17e7c6b3c80',
  [ENVIRONMENT.dev]: 'be3c39b7-1429-428d-8b8f-c17e7c6b3c80',
  [ENVIRONMENT.preprod]: 'f13793e9-bdc6-4be3-ac43-c51240be94aa',
  [ENVIRONMENT.prod]: '4b3995e5-6137-453e-9867-298b32cdb9b1',
  [ENVIRONMENT.localtest]: 'be3c39b7-1429-428d-8b8f-c17e7c6b3c80'
}

const TENANT_IDS = {
  [ENVIRONMENT.local]: '6e08b6be-0fec-4d35-a5d9-4aa4a42ecbf1',
  [ENVIRONMENT.dev]: '6e08b6be-0fec-4d35-a5d9-4aa4a42ecbf1',
  [ENVIRONMENT.preprod]: '37727452-1ffe-4a89-a215-7ad76ed85eb4',
  [ENVIRONMENT.prod]: '37727452-1ffe-4a89-a215-7ad76ed85eb4',
  [ENVIRONMENT.localtest]: '6e08b6be-0fec-4d35-a5d9-4aa4a42ecbf1'
  
}

// const AUTH_IDS = {
//   [ENVIRONMENT.local]: '6e08b6be-0fec-4d35-a5d9-4aa4a42ecbf1',
//   [ENVIRONMENT.dev]: '6e08b6be-0fec-4d35-a5d9-4aa4a42ecbf1',
//   [ENVIRONMENT.preprod]: '37727452-1ffe-4a89-a215-7ad76ed85eb4',
//   [ENVIRONMENT.prod]: '37727452-1ffe-4a89-a215-7ad76ed85eb4',
//   [ENVIRONMENT.localtest]: '6e08b6be-0fec-4d35-a5d9-4aa4a42ecbf1'
// }

const HOST_KEYS = {
  [ENVIRONMENT.local]: 'ug630v4Zo_QCaQgJ5H4hChOF31dE-CKVX4_9LuWk4SMjAzFuPXVnBg==',
  [ENVIRONMENT.dev]: 'ug630v4Zo_QCaQgJ5H4hChOF31dE-CKVX4_9LuWk4SMjAzFuPXVnBg==',
  [ENVIRONMENT.preprod]: '8gD-WHNu4EJqkrz8YjjrTHrnlUcuiBJJQ7wzeX-acUOLAzFuhTBfEA==',
  [ENVIRONMENT.prod]: 'zTv6YzyrQ0fil0Y5EMiKfd-ChbIi0jlcZ1tSy63QMl2CAzFuoYto3Q==',
  [ENVIRONMENT.localtest]: 'ug630v4Zo_QCaQgJ5H4hChOF31dE-CKVX4_9LuWk4SMjAzFuPXVnBg=='
}

export const getLoginUrl = () => {
  return LOGIN_URLS[getEnv()];
}

export const getClientId = () => {
  return CLIENT_IDS[getEnv()];
}

export const getTenantId = () => {
  return TENANT_IDS[getEnv()];
}

// export const getAuthId = () => {
//   return AUTH_IDS[getEnv()];
// }

export const getFunctionBaseUrl = () => {
  return BASE_URLS[getEnv()];
}

export const getHostKey = () => HOST_KEYS[getEnv()];
